(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('read-more-description')) {
    customElements.define(
      'read-more-description',
      class ReadMoreDescription extends HTMLElement {
        connectedCallback() {
          this.content = this.querySelector('.read-more__content');
          this.button = this.querySelector('.read-more__toggle');
          if (!this.content || !this.button) return;

          this.handleClick = this.toggle.bind(this);
          this.handleResize = () => {
            cancelAnimationFrame(this.frame);
            this.frame = requestAnimationFrame(() => this.checkLength());
          };

          this.button.addEventListener('click', this.handleClick);
          window.addEventListener('resize', this.handleResize);
          window.addEventListener('load', this.handleResize, { once: true });
          this.checkLength();
        }

        disconnectedCallback() {
          this.button?.removeEventListener('click', this.handleClick);
          window.removeEventListener('resize', this.handleResize);
          cancelAnimationFrame(this.frame);
        }

        get limit() {
          return parseFloat(getComputedStyle(this).getPropertyValue('--read-more-height')) || 160;
        }

        get reducedMotion() {
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }

        // Hide the button when the description is short enough to show in full
        checkLength() {
          if (this.hasAttribute('expanded')) return;
          const isShort = this.content.scrollHeight <= this.limit + 24;
          this.toggleAttribute('short', isShort);
          this.button.hidden = isShort;
        }

        toggle() {
          if (this.hasAttribute('expanded')) {
            this.collapse();
          } else {
            this.expand();
          }
        }

        expand() {
          const content = this.content;
          content.classList.add('is-animating');
          content.style.maxHeight = `${this.limit}px`;
          content.offsetHeight; // apply the starting height before animating
          this.setAttribute('expanded', '');
          content.style.maxHeight = `${content.scrollHeight}px`;
          this.afterTransition(() => {
            content.style.maxHeight = '';
            content.classList.remove('is-animating');
          });
          this.setState(true);
        }

        collapse() {
          const content = this.content;
          content.classList.add('is-animating');
          content.style.maxHeight = `${content.scrollHeight}px`;
          content.offsetHeight; // apply the starting height before animating
          this.removeAttribute('expanded');
          content.style.maxHeight = '';
          this.afterTransition(() => content.classList.remove('is-animating'));
          this.setState(false);

          // If the top of the description is now off screen, bring it back into view
          if (this.getBoundingClientRect().top < 0) {
            this.scrollIntoView({ block: 'start', behavior: this.reducedMotion ? 'auto' : 'smooth' });
          }
        }

        afterTransition(callback) {
          if (this.reducedMotion) {
            callback();
            return;
          }
          const onEnd = (event) => {
            if (event.propertyName !== 'max-height') return;
            this.content.removeEventListener('transitionend', onEnd);
            callback();
          };
          this.content.addEventListener('transitionend', onEnd);
        }

        setState(isOpen) {
          this.button.setAttribute('aria-expanded', String(isOpen));
          this.button.textContent = isOpen ? this.button.dataset.less : this.button.dataset.more;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
